import * as React from "react";
const SvgIcSortedDesc = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 13V3M6 13L3 9.99997M6 13L9 9.99997", stroke: "currentColor", strokeLinecap: "round" }));
export default SvgIcSortedDesc;
